import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {OpenGraphService} from "./open-graph.service";
import { LinkPreviewComponent } from "./link-preview/link-preview.component";

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    LinkPreviewComponent
  ],
  declarations: [
    LinkPreviewComponent
  ],
  providers: [
    OpenGraphService
  ]
})
export class OpenGraphModule { }
